import React, { useCallback, useMemo, useReducer } from 'react';

import compareModalConstants    from './compareModal.constants';
import CompareModalContext      from './compareModal.context';
import compareModalReducer      from './compareModal.reducer';
import compareModalInitialState from './compareModal.state';

/**
 * @type {React.FC}
 */

const CompareModalProvider = function({
  children,
  value = compareModalInitialState,
}) {
  const [state, dispatch] = useReducer(compareModalReducer, value);

  const hideCompareModal = useCallback(() => {
    dispatch({ type: compareModalConstants.HIDE_MODAL });
  }, [dispatch]);

  const showCompareModal = useCallback((door, comparisonLabel) => {
    dispatch({
      type:            compareModalConstants.SHOW_MODAL,
      door:            door,
      comparisonLabel: comparisonLabel,
    });
  }, [dispatch]);

  const context = useMemo(() => (
    {
      ...state,
      hideCompareModal,
      showCompareModal,
    }), [hideCompareModal, showCompareModal, state]);

  return (
    <CompareModalContext.Provider value={context}>
      {children}
    </CompareModalContext.Provider>
  );
};

export default CompareModalProvider;